import VueI18n from 'vue-i18n';
import * as constants from './constants';
import UserPreferredLocale from './UserPreferredLocale';
class OrI18n {
    constructor({ vueConstructor, router, orConfig, messages, getLocaleMessagesAsync }) {
        this.loadedLocales = [constants.FALLBACK_LOCALE];
        this.orConfig = orConfig;
        this.getLocaleMessagesAsync = getLocaleMessagesAsync;
        this.userPreferredLocale = new UserPreferredLocale(orConfig);
        this.createEventBus(vueConstructor);
        this.loadLocaleAsync = this.loadLocaleAsync.bind(this);
        vueConstructor.prototype.$loadLocaleAsync = this.loadLocaleAsync;
        vueConstructor.use(VueI18n);
        this.i18n = new VueI18n({
            locale: constants.FALLBACK_LOCALE,
            fallbackLocale: constants.FALLBACK_LOCALE,
            messages,
        });
        this.applyRouterGuard(router);
    }
    createEventBus(vueConstructor) {
        const EventBus = new vueConstructor();
        vueConstructor.prototype.$orI18nEventBus = EventBus;
        this.eventBus = EventBus;
        return EventBus;
    }
    applyRouterGuard(router) {
        if (router) {
            router.beforeEach((_to, _from, next) => {
                const userPrefLocale = this.userPreferredLocale.get();
                if (this.orConfig.SUPPORTED_LOCALES.includes(userPrefLocale)) {
                    return this.loadLocaleAsync(userPrefLocale).then(() => next());
                }
                return next();
            });
        }
        return router;
    }
    setI18nLocale(locale) {
        this.i18n.locale = locale;
        document.querySelector('html').setAttribute('lang', locale);
        this.eventBus.$emit('update:locale', locale);
        return locale;
    }
    loadLocaleAsync(locale) {
        if (this.i18n.locale === locale) {
            return Promise.resolve(locale);
        }
        this.userPreferredLocale.set(locale);
        if (this.loadedLocales.includes(locale)) {
            return Promise.resolve(this.setI18nLocale(locale));
        }
        return this.getLocaleMessagesAsync(locale).then(loadedMessages => {
            this.i18n.mergeLocaleMessage(locale, loadedMessages);
            this.loadedLocales.push(locale);
            return Promise.resolve(this.setI18nLocale(locale));
        });
    }
}
export default OrI18n;
//# sourceMappingURL=OrI18n.js.map